export default {
    language: 'Language', english: 'English', spanish: 'Spanish', japanese: 'Japanese',
    loading: 'Loading...', submit: 'Submit', cancel: 'Cancel', save: 'Save', clear: 'Clear', close: 'Close',
};
